import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

/**
 * @returns {Promise<AxiosResponse<any>>}
 * @constructor
 */
const GetRequest = (): Promise<AxiosResponse<any>> => Request.get(`employers/papdis`);

export default GetRequest;